import { httpClient } from "../../helpers/httpClient";
import { APP_API_URL, APP_API_VERSION } from "../../helpers/configuration";

export default {
  resetCampaignList({ commit }, payload) {
    commit("resetCampaignList", "");
    return "";
  },
  getCampaignsList({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    let parameters = "";
    if (payload.nextPageToken) {
      parameters = parameters + `&page_token=${payload.nextPageToken}`;
    }

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns?page_size=40${parameters}`;
    httpClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setCampaignsList", res.data);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns/${payload.campaignId}`;
    return httpClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setCampaign", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getCampaignReport({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns/${payload.campaignId}:generateOverviewReport`;
    return httpClient
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setCampaignReport", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getCampaignPreview({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns/${payload.campaignId}:preview`;
    return httpClient
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setCampaignPreview", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  sendCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns/${payload.campaignId}:send`;
    return httpClient
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Campaign sent" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Send error" }, { root: true });
        console.log(error);
      });
  },
  cancelCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${payload}:cancel`;
    return httpClient
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Campaign cancelled" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Cancel error" }, { root: true });
        console.log(error);
      });
  },
  deleteCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${payload}`;
    return httpClient
      .delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Campaign deleted" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Delete error" }, { root: true });
        console.log(error);
      });
  },
  updateCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns/${payload.campaignId}`;
    return httpClient
      .patch(url, payload.payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Campaign updated" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Update error" }, { root: true });
        console.log(error);
      });
  },
  createCampaign({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/campaigns`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Campaign created" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Create error" }, { root: true });
        console.log(error);
      });
  }
};
